
export const ResetTags = (itemArray) => {
  itemArray.forEach(element => {
    document.getElementById(element).checked = false;
  });
}